<template>
  <div class="wrap d-flex align-center" :style="styles">
    <div class="clickable mr-2" @click="reduce">
      <v-icon>mdi-minus</v-icon>
    </div>
    <div class="number-input">
      <v-text-field :value="value" @input="update" color="primary" hide-details="hide-details" dense="dense" outlined="outlined"></v-text-field>
    </div>
    <div class="clickable ml-2" @click="add">
      <v-icon>mdi-plus</v-icon>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    value: {
      type: Number,
      default: 0
    },
    width: {
      type: String,
      default: '100%'
    },
    maxWidth: {
      type: String,
      default: '160px'
    }
  },
  computed: {
    styles () {
      return {
        width: this.width,
        'max-width': this.maxWidth
      }
    }
  },
  methods: {
    update (value) {
      this.$emit('input', value)
    },
    add () {
      const newValue = this.value + 1
      this.update(newValue)
    },
    reduce () {
      const newValue = this.value - 1
      if (!this.check(newValue)) return
      this.update(newValue)
    },
    check (value) {
      if (value < 0) return false
      return true
    }
  }
}
</script>

<style lang="stylus" scoped>
  .clickable
    cursor pointer

  .number-input
    &/deep/ input
      text-align center
</style>
